module.exports={
    Cim: "https://nodejs201.dszcbaross.edu.hu"
    //Cim: "http://localhost:3000"
}


